import Vue from "vue";
export var EventBus = new Vue();
// 访问其他组件方法